import { createSlice } from "@reduxjs/toolkit";
import { AuthSignInRequest, AuthResetPasswordRequest, AuthUser } from "entities/auth";

type AuthState = {
  user: AuthUser | null;
  errors: Record<string, string[]> | string | null;
  isLoading: boolean;
  resetRequestSent: boolean;
};

const initialState: AuthState = {
  user: null,
  errors: null,
  isLoading: false,
  resetRequestSent: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Login
    loginRequest(state, action: { payload: AuthSignInRequest }) {
      void action.payload;
      state.isLoading = true;
      state.errors = null;
    },
    loginSuccess(state, action: { payload: AuthUser }) {
      state.isLoading = false;
      state.user = action.payload;
    },

    // Logout
    logoutRequest(state) {
      state.isLoading = true;
      state.errors = null;
    },
    logoutSuccess(state) {
      state.isLoading = false;
      state.user = null;
    },

    // Current user
    getCurrentUserRequest(state) {
      state.isLoading = true;
      state.errors = null;
    },
    getCurrentUserSuccess(state, action: { payload: AuthUser }) {
      state.isLoading = false;
      state.user = action.payload;
    },

    // Request password reset
    requestResetRequest(state, action: { payload: { email: string } }) {
      void action.payload;
      state.isLoading = true;
      state.errors = null;
      state.resetRequestSent = false;
    },
    requestResetSuccess(state) {
      state.isLoading = false;
      state.resetRequestSent = true;
    },
    requestResetFailure(state, action: { payload: string }) {
      state.isLoading = false;
      state.errors = action.payload;
    },

    // Reset password (set new password)
    resetPasswordRequest(state, action: { payload: AuthResetPasswordRequest }) {
      void action.payload;
      state.isLoading = true;
      state.errors = null;
    },
    resetPasswordSuccess(state, action: { payload: AuthUser }) {
      state.isLoading = false;
      state.user = action.payload;
    },
    resetPasswordFailure(state, action: { payload: string }) {
      state.isLoading = false;
      state.errors = action.payload;
    },

    // Errors
    setErrors(state, action: { payload: Record<string, string[]> | string | null }) {
      state.errors = action.payload;
      state.isLoading = false;
    },
    clearErrors(state) {
      state.errors = null;
    },

    // Reset request state
    clearResetRequestSent(state) {
      state.resetRequestSent = false;
    },
  },
});

export const {
  setErrors,
  clearErrors,
  loginRequest,
  loginSuccess,
  logoutRequest,
  logoutSuccess,
  getCurrentUserRequest,
  getCurrentUserSuccess,
  requestResetRequest,
  requestResetSuccess,
  requestResetFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  clearResetRequestSent,
} = authSlice.actions;
export default authSlice.reducer;
